import styled from 'styled-components';

import { Card } from '@atom/card/card';
import { Title } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const DashboardCard = styled(Card)`
  & .ant-card-head-title {
    font-size: 28px;
  }

  & .ant-card-head {
    padding: 24px 24px 20px;
  }
`;

export const WrapperChart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const WrapperChartSwitcher = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const ChartSwitchTitle = styled(Title).attrs({
  level: 6,
  weight: 500,
})<{ isActive: boolean }>`
  color: ${({ isActive }) => (isActive ? ColorEnum.Black100 : ColorEnum.Black40)};
  cursor: pointer;

  &:hover {
    color: ${ColorEnum.Black70};
  }
`;
